import { Modal } from "react-bootstrap";
import useLocalStorage from "../../hooks/useLocalStorage";
import { useState } from "react";
import Checkbox from "../Checkbox";
import { emails, localStorageVariables } from "../../constants";

export const ClaimsFileUploadNotice = () => {
  const [doNotShowAgain, setDoNotShowAgain] = useLocalStorage({
    key: localStorageVariables.doNotShowClaimNoticeAgain,
    initialValue: false,
  });
  const [doNotShowCheckboxState, setDoNotShowCheckboxState] =
    useState(doNotShowAgain);
  // Didn't use the useLocalStorage doNotShowAgain value here because it always comes up as the initialValue at this point, and then I guess on a re-render changes to the actual value it reads saved in local storage.
  //Would probably need to update the showModal state in a useEffect at that point or think of some other way to keep it in sync correctly.
  const [showModal, setShowModal] = useState(
    // this returns null if the local storage variable doesn't already exist so it doesn't break the first time the user gets to the page and the key doesn't exist in local storage.
    !JSON.parse(
      localStorage.getItem(localStorageVariables.doNotShowClaimNoticeAgain)
    )
  );

  const onToggleDoNotShowAgain = (e) => {
    setDoNotShowCheckboxState(e.target.checked);
  };
  const onClickGotIt = () => {
    setDoNotShowAgain(doNotShowCheckboxState);
    setShowModal(false);
  };
  //   console.log(doNotShowCheckboxState);
  //   console.log("do not show again local storage value: ", doNotShowAgain);
  //   console.log("show modal state value: ", showModal);
  return (
    <Modal show={showModal} onHide={() => {}} backdrop="static">
      <Modal.Header>
        <Modal.Title>Claim File Upload</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        You may now upload supporting images and documents from this page when
        you file a claim.
        <br />
        <br />
        <div className="pl-2">
          Examples of documents include:
          <br />
          <ul>
            <li>PDFs of invoices showing dealer cost information.</li>
            <li>Images of damage.</li>
            <li>Excel sheets with dealer cost information.</li>
          </ul>
        </div>
        <div className="text-danger">At least 1 file is required.</div>
        If you have questions on what documents you need for your claim, contact{" "}
        {emails.claimsEmail}.
      </Modal.Body>
      <Modal.Footer>
        <Checkbox
          name="doNotShowAgain"
          label="Don't show again"
          className="mr-2"
          onChange={onToggleDoNotShowAgain}
        />
        <button
          className="btn btn-primary"
          type="button"
          onClick={onClickGotIt}
        >
          Got it!
        </button>
      </Modal.Footer>
    </Modal>
  );
};
